/* global togpx */
/* global tokml */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTrailCollectionForExport } from '../../store/presentationSelector';
import { saveString2File } from '../../helpers/fileHelper';
import GetAppIcon from '@material-ui/icons/GetApp';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

const ExportAndDownload = (props) => {
    const { collection, fileName } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const saveGPX = () => {
        const gpx = togpx(collection);
        saveString2File(gpx, `${fileName}.gpx`);
        handleClose();
    };
    const saveKML = () => {
        const kml = tokml(collection);
        saveString2File(kml, `${fileName}.kml`);
        handleClose();
    };
    const saveGeoJSON = () => {
        saveString2File(JSON.stringify(collection), `${fileName}.geojson`);
        handleClose();
    };
    return (
        <>
            <Tooltip title="Download">
                <Fab color="primary" aria-label="add" onClick={handleClick}>
                    <GetAppIcon />
                </Fab>
            </Tooltip>
            <StyledMenu
                id="customized-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <StyledMenuItem onClick={saveGPX}>
                    <ListItemText primary="GPX" />
                </StyledMenuItem>
                <StyledMenuItem onClick={saveKML}>
                    <ListItemText primary="KML" />
                </StyledMenuItem>
                <StyledMenuItem onClick={saveGeoJSON}>
                    <ListItemText primary="GeoJSON" />
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        collection: getTrailCollectionForExport(state),
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportAndDownload);
